import { combineReducers } from 'redux';

import publicEventReducer from './publicEventReducer';

const publicReducer = combineReducers({
  events: publicEventReducer,
});
export default publicReducer;
